import { callActiveAll, callArchiveAll, callDeleteAll, callSearch } from "../../haz/request/request.logic";
import store from "../../../../store/index";
import { flatWhereGroup } from "../../../../utils/search";
import { has } from "../../../../utils/menu-context";
import {
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../../utils/page";
import i18n from "../../../../i18n";
import { openModalForm as openModalFormConfirmApprove } from "../../storage-location/request/modal/confirm-approve.logic";
import { reactive } from "vue";
import { notification } from "ant-design-vue";
import { onClickActiveAll, onClickArchiveAll, onClickCreate, onClickDeleteAll, onClickEdit, onClickView } from "../../../../utils/form";
import { createColumns } from "../../haz-license/request/request.section";
import { createConditionAction } from "../../haz-license/request/request.condition";
import { createLoading } from "../../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callRequestAll = ({ forms }) => store.dispatch(`${actionPrefix}/requestAll`, { data: forms });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "refToApproveBy.username", type: "String", operator: "=", value: userInfo.username }, { logic: "AND", name: "refRequestDoc.key", type: "String", operator: "in", value: has({ menuContext, key: "forHazLicenseNotice" }) ? ["12", "13", "14", "15"] : ["08", "09", "10", "11"] }]);
    return flatWhereGroup({ where: whereGroup, logic: "OR" });
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [
        createManageSelect({ menuContext }),
        {
            icon: () => <CIcon file="check.svg"></CIcon>,
            text: () => i18n.global.t("button.signApprove"),
            force: true,
            visible: () => true,
            rowSelection: true,
            buttonProp: { class: "btn-success" },
            onClick: ({ rowSelection }) => {
                openModalFormConfirmApprove({
                    onOk: record => {
                        const forms = rowSelection.selectedRows.map(d => ({ ...d, refStatus: record.refStatus }));
                        setIsLoading(true);
                        callRequestAll({ forms })
                            .then(() => notification["success"]({ message: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`) }))
                            .then(() => onSearch({ props, page: state.page }))
                            .finally(() => setIsLoading(false));
                    }
                });
            },
            getCheckboxProps: ({ record }) => ({ disabled: record.refStatus?.key !== "waitApprove" })
        },
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        })
    ];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: [
                "**",
                "refHazLicense.**",
                "refHazLicenseTemp.**",
                "refHazLicenseTemp.refUserCompany.*",
                "refHazLicenseTemp.refUserCompany.refPersonType.*",
                "refHazLicenseTemp.refOperation.*",
                "refHazLicenseTemp.refSpecies.*",
                "refRequestType.*",
                "refStatus.*"
            ],
            children: [
                {
                    name: "refHazLicenseTemp.hazLicenseDetails",
                    select: ["*", "refHaz.refOperation.*", "refHaz.refHazObject.refSpecies.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
            ],
            sort: [/* { name: "refStatus.seq", type: "ASC" } ,*/ { name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
